<!-- <template>
  <div>
    <div class="debug-panel"></div>
    <div class="skeleton-loader-wrapper">
      <SkeletonLoader :loadingText="loadingText" />
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { useMyStore } from '../store.js';
import SkeletonLoader from '../components/SkeletonLoader.vue';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export default {
  components: {
    SkeletonLoader,
  },
  setup() {
    const {
      loginWithRedirect,
      isAuthenticated,
      isLoading,
      getAccessTokenSilently,
      user
    } = useAuth0();

    const store = useMyStore();
    const loading = ref(true);
    const loadingText = ref('Logging in');
    const baseURL = import.meta.env.VITE_BASE_URL;
    const env = import.meta.env.MODE;
    const isNative = Capacitor.isNativePlatform();

    const handlePostLogin = async () => {
      try {
        loadingText.value = 'Loading user data';

        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          },
        });

        store.setAuthToken(token);
        localStorage.setItem('authToken', token);

        const userInfo = user.value || (await store.fetchAuth0UserInfo(token));

        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        store.setUserInfo(userInfo);
        store.setAuthInitialized(true);
      } catch (error) {
        console.error('Post-login handling failed:', error);
      } finally {
        loading.value = false;
      }
    };

    // onMounted(async () => {
    //   console.log('SignIn mounted');

    //   while (isLoading.value) {
    //     await new Promise((resolve) => setTimeout(resolve, 50));
    //   }

    //   console.log('signin isloading ' + isLoading.value);

    //   console.log(
    //     'is authenticated value at sign in mounted ' + isAuthenticated.value
    //   );

    //   console.log('is user logged in store ' + store.userLoggedIn);

    //   if (!isAuthenticated.value) {
    //     console.log('Starting login redirect...');
    //     await loginWithRedirect({
    //       appState: { targetUrl: '/' },
    //       authorizationParams: {
    //         audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    //         scope: 'openid profile email',
    //       },
    //     });
    //   } else {
    //     console.log('hits else signin mounted - user is authenticated');
    //     await handlePostLogin();
    //   }

    //   if (!isAuthenticated.value) {
    //     const justLoggedOut = sessionStorage.getItem('justLoggedOut') === '1';

    //     if (isNative && justLoggedOut) {
    //       console.log('[Auth] Skipping auto-login because user just logged out');
    //       loadingText.value = 'Logged out';
    //       loading.value = false;
    //       return;
    //     }

    //     console.log('Starting login redirect...');
    //     await loginWithRedirect({
    //       appState: { targetUrl: '/' },
    //       authorizationParams: {
    //         audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    //         scope: 'openid profile email',
    //       },
    //     });
    //   } else {
    //     console.log('hits else signin mounted - user is authenticated');
    //     await handlePostLogin();
    //   }
    // });

    onMounted(async () => {
      console.log('SignIn mounted');

      while (isLoading.value) {
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      console.log('signin isLoading', isLoading.value);
      console.log('signin isAuthenticated', isAuthenticated.value);

      if (isAuthenticated.value) {
        console.log('Already authenticated -> post login');
        await handlePostLogin();
        return;
      }

      console.log('Starting login redirect...');

      await loginWithRedirect({
        appState: { targetUrl: '/' },
        authorizationParams: {
          audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          scope: 'openid profile email',
        },
        ...(isNative
          ? {
              openUrl: async (url) => {
                console.log('[Auth] openUrl (native) ->', url);
                await Browser.open({ url });
              },
            }
          : {}),
      });
    });

    watch(isAuthenticated, async (newVal) => {
      console.log('watch hit isauthenticated');
      console.log('newval ' + newVal);
      if (newVal) {
        await handlePostLogin();
      } else {
        window.location.reload();
      }
    });

    return {
      loading,
      loadingText,
      baseURL,
      env,
    };
  },
};
</script> -->

<!-- commenting this out on march 23rd to update to a modern UI -->
<!-- <template>
  <div v-if="loading">
    <div class="skeleton-loader-wrapper">
      <SkeletonLoader :loadingText="loadingText" />
    </div>
  </div>  
  <div v-else class="signin-page-button">
    <div class="signin-card">
      <img :src="appIcon" alt="App Icon" class="app-icon w-100" />
      <h1 class="title">Welcome to Lucky Friday</h1>
      <p class="subtitle">Sign in to continue.</p>

      <button class="button teal-outline-button w-100" @click="startLogin">
        Sign in
      </button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { useMyStore } from '../store.js';
import SkeletonLoader from '../components/SkeletonLoader.vue';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { useRouter } from 'vue-router';
import appIcon from '@/assets/images/brightlogo.png';

export default {
  components: { SkeletonLoader },
  setup() {
    const {
      loginWithRedirect,
      isAuthenticated,
      isLoading,
      getAccessTokenSilently,
      user,
    } = useAuth0();

    const store = useMyStore();
    const router = useRouter();

    const loading = ref(true);
    const loadingText = ref('Loading');

    const isNative = Capacitor.isNativePlatform();

    const handlePostLogin = async () => {
      console.log('hits handle post login');
      try {
        loading.value = true;
        loadingText.value = 'Loading user data';

        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          },
        });

        store.setAuthToken(token);
        localStorage.setItem('authToken', token);

        const userInfo = user.value || (await store.fetchAuth0UserInfo(token));
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        store.setUserInfo(userInfo);
        store.setAuthInitialized(true);
      } catch (error) {
        console.error('Post-login handling failed:', error);
        loading.value = false;
      } 
    };

    const startLogin = async () => {
      try {
        console.log('hits startlogin')
        loading.value = true;
        loadingText.value = 'Opening sign in';

        await loginWithRedirect({
          appState: { targetUrl: '/' },
          authorizationParams: {
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
            scope: 'openid profile email',
          },
          ...(isNative
            ? {
                openUrl: async (url) => {
                  console.log('[Auth] openUrl (native) ->', url);
                  await Browser.open({ url });
                },
              }
            : {}),
        });
        if (isNative) {
          loading.value = false;
        }
      } catch (e) {
        console.error('Login failed to start:', e);
        loading.value = false;
      }
    };

    onMounted(async () => {
      loading.value = true;
      console.log('mounting sign in vue!');

      console.log('isloading on mounted ' + isLoading.value);
      
      while (isLoading.value) {
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      if (isAuthenticated.value) {
        console.log('inside isauthenticated');
        await handlePostLogin();
        return;
      }
      else {
        loading.value = false;
        loadingText.value = 'Ready';
      }
    });
    
    watch(isAuthenticated, async (newVal) => {
      console.log('hits the watch is authenticated ');
      if (newVal && store.userLoggedIn) {
        console.log('hits inside if isauthenticated');
        await handlePostLogin();
      }else {
        window.location.reload();
      }
    });

    return {
      loading,
      loadingText,
      startLogin,
      appIcon
    };
  },
};
</script>

<style scoped>
.signin-page {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4em;
}

.signin-page-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80%;
  background: linear-gradient(180deg, rgba(68, 255, 205, 0.15) 0%, #ffffff 10%);
}

.skeleton-loader-wrapper {
  width: 100%;
}

.title {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 700;
  color: #004751;
}

.subtitle {
  margin: 0 0 20px 0;
  opacity: 0.8;
}

.signin-card {
  width: 50%;
  max-width: 500px;
}

@media screen and (min-width: 992px) {
  .signin-page-button {
    padding: 4em;
  }
}
</style> -->

<template>
  <div v-if="loading" class="skeleton-loader-wrapper">
    <SkeletonLoader :loadingText="loadingText" />
  </div>
  <div v-else class="signin-page">
    <div class="bg-orb orb1"></div>
    <div class="bg-orb orb2"></div>

    <div class="signin-card">
      <div class="logo-wrap">
        <img :src="mintAppIcon" alt="Lucky Friday" class="logo-img" />
        <div class="logo-shine"></div>
        <div class="logo-pulse"></div>
      </div>

      <p class="eyebrow">
        Your bank has the data. Lucky Friday makes sense of it.
      </p>
      <h1 class="headline">Your Money. Your Rules.</h1>
      <p class="sub">
        Connect your accounts, set your categories, and see everything in one
        place. Takes 7 minutes to set up.
      </p>

      <button class="btn-primary" @click="startLogin">
        Sign in to continue
      </button>

      <div class="trust-row">
        <div class="trust-item">
          <div class="trust-dot"></div>
          Bank-level security
        </div>
        <div class="trust-item">
          <div class="trust-dot"></div>
          No hidden fees
        </div>
        <div class="trust-item">
          <div class="trust-dot"></div>
          Cancel any time
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { useMyStore } from '../store.js';
import SkeletonLoader from '../components/SkeletonLoader.vue';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import appIcon from '@/assets/images/brightlogo.png';
import mintAppIcon from '@/assets/images/LuckyFridayBrightIcon.png';
import { Purchases } from '@revenuecat/purchases-capacitor';

export default {
  components: { SkeletonLoader },
  setup() {
    const {
      loginWithRedirect,
      isAuthenticated,
      isLoading,
      getAccessTokenSilently,
      user,
    } = useAuth0();

    const store = useMyStore();

    const loading = ref(true);
    const loadingText = ref('Loading');
    const isNative = Capacitor.isNativePlatform();

    const handlePostLogin = async () => {
      try {
        loading.value = true;
        loadingText.value = 'Loading user data';

        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          },
        });

        store.setAuthToken(token);
        localStorage.setItem('authToken', token);

        const userInfo = user.value || (await store.fetchAuth0UserInfo(token));
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        store.setUserInfo(userInfo);

        if (Capacitor.isNativePlatform()) {
          try {
            await Purchases.logIn({ appUserID: userInfo.sub });
          } catch (e) {
            console.error('RevenueCat logIn failed: ', e.message);
          }
        }

        store.setAuthInitialized(true);
      } catch (error) {
        console.error('Post-login handling failed:', error);
        loading.value = false;
      }
    };

    const startLogin = async () => {
      try {
        loading.value = true;
        loadingText.value = 'Opening sign in';

        await loginWithRedirect({
          appState: { targetUrl: '/' },
          authorizationParams: {
            audience: import.meta.env.VITE_AUTH0_AUDIENCE,
            scope: 'openid profile email',
          },
          ...(isNative
            ? {
                // openUrl: async (url) => {
                //   console.log('[Auth] openUrl (native) ->', url);
                //   await Browser.open({ url });
                openUrl: async (url) => {
                  console.log('[Auth] openUrl (native) ->', url);
                  const isIpad =
                    /iPad/i.test(navigator.userAgent) ||
                    (navigator.platform === 'MacIntel' &&
                      navigator.maxTouchPoints > 1);
                  await Browser.open({
                    url,
                    presentationStyle: isIpad ? 'popover' : 'fullscreen',
                  });
                },
              }
            : {}),
        });
        if (isNative) {
          loading.value = false;
        }
      } catch (e) {
        console.error('Login failed to start:', e);
        loading.value = false;
      }
    };

    onMounted(async () => {
      loading.value = true;

      if (sessionStorage.getItem('force_manual_login') === '1') {
        sessionStorage.removeItem('force_manual_login');
        loading.value = false;
        loadingText.value = 'Session expired. Please sign in again.';
        return;
      }

      const token = localStorage.getItem('authToken');
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          if (Date.now() >= payload.exp * 1000) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('userInfo');
          }
        } catch (e) {
          localStorage.removeItem('authToken');
        }
      }

      const isLogoutInProgress =
        sessionStorage.getItem('logout_in_progress') === '1';
      if (isLogoutInProgress) {
        sessionStorage.removeItem('logout_in_progress');
        loading.value = false;
        loadingText.value = 'Ready';
        return;
      }

      while (isLoading.value) {
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      if (isAuthenticated.value) {
        await handlePostLogin();
        return;
      } else {
        loading.value = false;
        loadingText.value = 'Ready';
      }
    });

    // onMounted(async () => {
    //   loading.value = true;
    //   console.log('mounting sign in vue! ');
    //   console.log('isloading on mounted ' + isLoading.value);

    //   while (isLoading.value) {
    //     await new Promise((resolve) => setTimeout(resolve, 50));
    //   }

    //   if (isAuthenticated.value) {
    //     console.log('inside isauthenticated ');
    //     await handlePostLogin();
    //     return;
    //   } else {
    //     loading.value = false;
    //     loadingText.value = 'Ready';
    //   }
    // });

    watch(isAuthenticated, async (newVal) => {
      if (sessionStorage.getItem('force_manual_login') === '1') {
        return;
      }

      const isLogoutInProgress =
        sessionStorage.getItem('logout_in_progress') === '1';

      if (isLogoutInProgress) {
        return;
      }

      if (newVal) {
        // User just authenticated (new user or returning user)
        await handlePostLogin();
      }
    });

    // watch(isAuthenticated, async (newVal) => {
    //   console.log('hits the watch is authenticated');
    //   if (store.isLoggingOut) {
    //     console.log('Logout in progress, ignoring auth change');
    //     return;
    //   }
    //   if (newVal && store.userLoggedIn) {
    //     console.log('hits inside if isauthenticated');
    //     await handlePostLogin();
    //   }
    //   else if (newVal && !store.userLoggedIn) {
    //     console.log('newval ' + newVal)
    //     window.location.reload();
    //   }
    // });

    return {
      loading,
      loadingText,
      startLogin,
      appIcon,
      mintAppIcon,
    };
  },
};
</script>

<style scoped>
.signin-page {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.5rem;
  position: relative;
  overflow: hidden;
  background: white;
}

.dark-theme .signin-page {
  background: #171e29;
}

.bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  pointer-events: none;
  z-index: 0;
}

.orb1 {
  width: 320px;
  height: 320px;
  background: rgba(127, 119, 221, 0.1);
  top: -100px;
  right: -80px;
}

.orb2 {
  width: 240px;
  height: 240px;
  background: rgba(93, 202, 165, 0.09);
  bottom: -40px;
  left: -80px;
}

.signin-card {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 340px;
}

.logo-wrap {
  position: relative;
  width: 110px;
  height: 110px;
  margin-bottom: 1.75rem;
  border-radius: 26px;
  overflow: hidden;
  animation: popIn 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;
}

@keyframes popIn {
  from {
    transform: scale(0) rotate(-8deg);
    opacity: 0;
  }
  to {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}

.logo-img {
  width: 100%;
  height: 100%;
  border-radius: 26px;
  display: block;
}

.logo-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    105deg,
    transparent 30%,
    rgba(255, 255, 255, 0.55) 50%,
    transparent 70%
  );
  animation:
    shineSweep 0.9s ease 0.8s forwards,
    shineRepeat 5s ease 2.5s infinite;
  pointer-events: none;
}

@keyframes shineSweep {
  from {
    left: -100%;
  }
  to {
    left: 150%;
  }
}

@keyframes shineRepeat {
  0%,
  100% {
    left: -100%;
    opacity: 1;
  }
  18% {
    left: 150%;
    opacity: 1;
  }
  19%,
  99% {
    left: -100%;
    opacity: 0;
  }
}

.logo-pulse {
  position: absolute;
  inset: 0;
  border-radius: 26px;
  animation: pulseRing 3s ease-in-out 1.8s infinite;
  pointer-events: none;
}

@keyframes pulseRing {
  0% {
    box-shadow: 0 0 0 0 rgba(72, 255, 205, 0.45);
  }
  60% {
    box-shadow: 0 0 0 14px rgba(72, 255, 205, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(72, 255, 205, 0);
  }
}

/* Text */
.eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #7f77dd;
  margin-bottom: 0.6rem;
  text-align: center;
  animation: slideUp 0.5s ease 0.3s both;
}

.headline {
  font-size: 2rem;
  font-weight: 800;
  color: #004751;
  line-height: 1.15;
  text-align: center;
  letter-spacing: -0.03em;
  margin-bottom: 0.75rem;
  animation: slideUp 0.5s ease 0.4s both;
}

.dark-theme .headline {
  color: #ffffff;
}

.headline span {
  background: linear-gradient(135deg, #7f77dd, #5dcaa5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sub {
  font-size: 0.88rem;
  color: #888;
  text-align: center;
  line-height: 1.6;
  max-width: 290px;
  margin-bottom: 2rem;
  animation: slideUp 0.5s ease 0.5s both;
}

@keyframes slideUp {
  from {
    transform: translateY(16px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.btn-primary {
  width: 100%;
  border: none;
  border-radius: 50px;
  padding: 0.85rem;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  background: linear-gradient(135deg, #7f77dd, #5dcaa5);
  color: white;
  cursor: pointer;
  box-shadow: 0 6px 24px rgba(127, 119, 221, 0.3);
  transition:
    transform 0.15s,
    box-shadow 0.15s;
  animation: slideUp 0.5s ease 0.6s both;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 32px rgba(127, 119, 221, 0.4);
}

.btn-primary:active {
  transform: scale(0.97);
}

.trust-row {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1.75rem;
  animation: slideUp 0.5s ease 0.75s both;
}

.trust-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #aaa;
  font-weight: 500;
}

.trust-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #5dcaa5;
  flex-shrink: 0;
}

@media screen and (min-width: 992px) {
  .signin-page {
    padding: 4rem;
  }

  .headline {
    font-size: 2.4rem;
  }
}
</style>
